module.exports = __webpack_public_path__ + "static/img/bkjbz2.8ffd85b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity/welcome/bkjbz2.png
// module id = +QT7
// module chunks = 0